/**
 * External dependencies
 */
import React, { useState, useEffect } from 'react';
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import Money from 'components/money';
import Preloader from 'components/preloader';
import cscom from 'lib/customer-site-api';

/**
 * Style dependencies
 */
import './styles.scss';
import { Stack, Box, Text, Heading } from '@towersystems/towersystems-design-system';
import DateTime from 'components/date-time';

const NewPlanEstimate = ({ subscriptionId, newPlanId, plan, addon }) => {
    const [submitting, setSubmitting] = useState(false);
    const [requesting, setRequesting] = useState(true);
    const [estimate, setEstimate] = useState(null);

    useEffect(() => {
        setRequesting(true);
        cscom
            .estimate()
            .updateSubscription(subscriptionId, newPlanId)
            .then((estimate) => setEstimate(estimate))
            .catch((a) => console.log(a))
            .finally(() => setRequesting(false));
    }, []);

    const getEstimate = (estimate) => {
        if (!estimate) {
            return '-';
        }

        if (estimate.next_invoice_estimate) {
            return get(estimate, 'next_invoice_estimate.total', 0) / 100;
        }

        if (estimate.invoice_estimate) {
            return get(estimate, 'invoice_estimate.total', 0) / 100;
        }

        return '-';
    };

    const getDiscounts = (estimate) => {
        if (!estimate) {
            return [];
        }
        if (estimate.next_invoice_estimate) {
            return get(estimate, ['next_invoice_estimate', 'discounts'], []);
        }
        if (estimate.invoice_estimate) {
            return get(estimate, ['invoice_estimate', 'discounts'], []);
        }
        return [];
    };

    return (
        <Box className='new-plan-estimate' display='flex' flexDirection='column' justifyContent='center'>
            {submitting || (requesting && <Preloader />)}
            <Stack space='medium'>
                <div style={{ fontSize: 22, textAlign: 'center', fontWeight: 'bold' }}>{plan.name}</div>
                <Text align='center' size='xsmall'>
                    {plan.description}
                </Text>
                <Box padding='large'>
                    <div style={{ fontSize: 38, textAlign: 'center' }}>
                        <Money value={getEstimate(estimate)} />*
                    </div>
                    <Text align='center' size='small'>
                        Charge on <DateTime date={get(estimate, 'subscription_estimate.next_billing_at')} format='Do MMM, YYYY' />.
                    </Text>
                </Box>
                <Box style={{ textAlign: 'center' }}>
                    <div>* Estimated amount only</div>
                    {getDiscounts(estimate).map((discount) => {
                        return (
                            <Box key={discount.entity_id}>
                                <div>* Including {discount.description}</div>
                            </Box>
                        );
                    })}
                </Box>
            </Stack>
        </Box>
    );
};

export default NewPlanEstimate;
